module.exports = __webpack_public_path__ + "static/img/planLeft1.9a238bc6.png";